import React, { Component } from 'react';
import autobind from 'react-autobind'

export class Page extends Component {

    constructor(props) {
        super(props);
        autobind(this);
    }

    render() {
        const { text, pageCount, onClick, isCurrent } = this.props

        return (
            <li className={`page-item ${isCurrent ? 'active' : ''}`}>
                <span className="page-link" onClick={(e) => onClick(e, (pageCount - 1))}>{text ? text : pageCount}</span>
            </li>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/Pagination/Page.js